export default __webpack_public_path__ + "static/americanabt_bold-587d821f7e0c3b603b98df00dc3991ae.woff2";